"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHuntLogo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3998 14.1H10.425V17.25H8.32499V6.75H13.3998C15.4296 6.75 17.0748 8.39522 17.0748 10.425C17.0748 12.4548 15.4296 14.1 13.3998 14.1ZM12 1.5C6.20072 1.5 1.5 6.20072 1.5 12C1.5 17.7993 6.20072 22.5 12 22.5C17.7986 22.5 22.5 17.7993 22.5 12C22.5 6.20072 17.7986 1.5 12 1.5ZM13.3998 8.84999H10.425V12H13.3998C14.27 12 14.9748 11.2945 14.9748 10.425C14.9748 9.55547 14.27 8.84999 13.3998 8.84999Z", fill: "black" }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.8664 18.8H13.9V23H11.1V9H17.8664C20.5728 9 22.7664 11.1936 22.7664 13.9C22.7664 16.6064 20.5728 18.8 17.8664 18.8ZM16 2C8.26762 2 2 8.26762 2 16C2 23.7324 8.26762 30 16 30C23.7315 30 30 23.7324 30 16C30 8.26762 23.7315 2 16 2ZM17.8664 11.8H13.9V16H17.8664C19.0266 16 19.9664 15.0594 19.9664 13.9C19.9664 12.7406 19.0266 11.8 17.8664 11.8Z", fill: "black" }, void 0) }), void 0));
};
var ProductHuntLogo = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.ProductHuntLogo = ProductHuntLogo;
//# sourceMappingURL=ProductHuntLogo.js.map